import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { useUser } from "../../../../../../hooks/useUser";
import { getFullUserName } from "../../utils/getFullUserName";
import styles from "./UserIndicationButton.module.scss";
export const UserIndicationButtonMobile = () => {
    const { user, isUserLoggedIn } = useUser();
    const userName = getFullUserName(user);
    if (!isUserLoggedIn) {
        return null;
    }
    return (_jsx("div", { className: styles.navigationUsername, children: _jsxs("div", { className: styles.userButtonWrapperMobile, children: [_jsx("div", { className: classNames(styles.userButton), children: _jsx("div", { className: classNames(styles.userButtonLogged, styles.userButtonLoggedNordic, styles.userLetterWithName), children: userName?.[0]?.toLocaleUpperCase() }) }), _jsx("span", { className: styles.userButtonNameMobile, children: userName })] }) }));
};
//# sourceMappingURL=UserIndicationButtonMobile.js.map